// extracted by mini-css-extract-plugin
module.exports = {"module":"PayrollTransactionBase_module__15oNZ"};